import React from "react";
import YoutubeVideo from "./youtubeVideo";
import YoutubeVideoContainer from "./youtubeVideoContainer";


interface Props {
    videos: Array<YoutubeVideo>;
}

/**
 * Displays a list with YouTube videos
 */
export default class YoutubeList extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);

    }

    render() {
        let videos = Array<JSX.Element>();
        let count = 0;
        for (let video of this.props.videos) {
            let active = "";
            if (count === 0) {
                active = "active";
            }
            videos.push(
                <div
                    className={"mb-5 display-list-item " + active}
                    key={video.embedCode}
                >
                    <YoutubeVideoContainer video={video} />
                    <p className="mt-2">
                        {video.caption}
                    </p>
                </div>
            );
            count++;
        }

        return (
            <div className="row video-row mb-5 pb-4">
                <div className="col-12">
                    <div
                        id="videoDisplayList"
                        className=""
                    >
                        <div className="carousel-inner">{videos}</div>
                    </div>
                </div>
            </div>
        );
    }
}
